export enum LayoutKeyEnum {
    Default = 'layout',
    GeneralMeeting = 'gmLayout'
}
